





























































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { Crop } from '@/models/crop';
import { CropType } from '@/models/crop-type';
import { Variety, SeedType } from '@/models/variety';
import { Compact } from 'vue-color';
import firebase from 'firebase';

@Component(
    {
        components: {
            'compact-picker': Compact,
        },
    },
)
export default class CropsComponent extends Vue {
    @State('crops') private cropsState: any;
    @Action('getCrops') private getCropsAction: any;
    @Action('getCropTypes') private getCropTypesAction: any;
    @Action('getVarieties') private getVarietiesAction: any;

    private cropsRef = firebase.firestore().collection('crops');
    private cropTypesRef = firebase.firestore().collection('cropTypes');
    private varietiesRef = firebase.firestore().collection('varieties');

    private isAddingCrop = false;
    private isAddingCropType = false;
    private isAddingVariety = false;
    private isEditingCrop = false;
    private isEditingCropType = false;
    private isEditingVariety = false;
    private isDeletingCrop = false;
    private isDeletingCropType = false;
    private isDeletingVariety = false;

    private currentlyEditingCropId = '';
    private currentlyEditingCropTypeId = '';

    private currentlyEditingCrop: Crop | undefined = undefined;
    private currentlyEditingCropType: CropType | undefined = undefined;
    private currentlyEditingVariety: Variety | undefined = undefined;

    private currentlyDeletingCrop: Crop | undefined = undefined;
    private currentlyDeletingCropType: CropType | undefined = undefined;
    private currentlyDeletingVariety: Variety | undefined = undefined;

    private items = [
        {
            text: 'Pelleted',
            value: SeedType.Pelleted,
        },
        {
            text: 'Raw',
            value: SeedType.Raw,
        },
    ];

    // Form variables
    private cropName = '';
    private cropTypeName = '';
    private varietyName = '';
    private varietySeedType = '';
    private varietyCropCode = '';
    private varietyColor = '#194D33';

    private created(): void {
        this.getCropsAction();
    }

    private loadCropTypes(cropId: string) {
        this.getCropTypesAction(cropId);
    }

    private loadVarieties(cropId: string, cropTypeId: string) {
        this.getVarietiesAction({cropId, cropTypeId});
    }

    private submitCrop() {
        this.cropsRef.add(
            {
                name: this.cropName,
            },
        ).then(() => {
            this.getCropsAction();
            this.cropName = '';
            this.isAddingCrop = false;
        }).catch((err) => {
            alert('Oops: ' + err);
        });
    }

    private submitCropType() {
        this.cropTypesRef.add(
            {
                cropId: this.cropsRef.doc(this.currentlyEditingCropId),
                name: this.cropTypeName,
            },
        ).then(() => {
            this.loadCropTypes(this.currentlyEditingCropId);
            this.cropTypeName = '';
            this.currentlyEditingCropId = '';
            this.isAddingCropType = false;
        }).catch((err) => {
            alert('Oops: ' + err);
        });
    }

    private submitVariety() {
        this.varietiesRef.add(
            {
                cropTypeId: this.cropTypesRef.doc(this.currentlyEditingCropTypeId),
                name: this.varietyName,
                seedType: this.varietySeedType,
                cropCode: this.varietyCropCode,
                color: this.varietyColor,
            },
        ).then(() => {
            this.loadVarieties(this.currentlyEditingCropId, this.currentlyEditingCropTypeId);
            this.varietyName = '';
            this.currentlyEditingCropId = '';
            this.currentlyEditingCropTypeId = '';
            this.varietyColor = '#194D33';
            this.isAddingVariety = false;
        }).catch((err) => {
            alert('Oops: ' + err);
        });

    }

    private setAddingCropType(cropId: string) {
        this.currentlyEditingCropId = cropId;
        this.isAddingCrop = false;
        this.isAddingCropType = true;
        this.isAddingVariety = false;
    }

    private setAddingVariety(cropId: string, cropTypeId: string) {
        this.currentlyEditingCropId = cropId;
        this.currentlyEditingCropTypeId = cropTypeId;
        this.isAddingCrop = false;
        this.isAddingCropType = false;
        this.isAddingVariety = true;
    }

    private setEditingCrop(crop: Crop) {
        this.currentlyEditingCrop = crop;
        this.isEditingCrop = true;
        this.cropName = crop.name;
    }

    private submitEditingCrop() {
        const crop = this.currentlyEditingCrop!!;

        this.cropsRef.doc(crop.id).update(
            {name: this.cropName},
        ).then(() => {
            this.cancelEditingCrop();
            this.getCropsAction();
        });
    }

    private cancelEditingCrop() {
        this.currentlyEditingCrop = undefined;
        this.isEditingCrop = false;
        this.cropName = '';
    }

    private setEditingCropType(cropType: CropType) {
        this.currentlyEditingCropType = cropType;
        this.isEditingCropType = true;
        this.cropTypeName = cropType.name;
    }

    private submitEditingCropType() {
        const cropType = this.currentlyEditingCropType!!;

        this.cropTypesRef.doc(cropType.id).update(
            {name: this.cropTypeName},
        ).then(() => {
            this.cancelEditingCropType();
            this.getCropTypesAction(cropType.cropId);
        });
    }

    private cancelEditingCropType() {
        this.currentlyEditingCropType = undefined;
        this.isEditingCropType = false;
        this.cropTypeName = '';
    }

    private setEditingVariety(variety: Variety, cropId: string) {
        this.currentlyEditingVariety = variety;
        // Needed for submit
        this.currentlyEditingCropId = cropId;
        this.isEditingVariety = true;
        this.varietyName = variety.name;
        this.varietySeedType = variety.seedType;
        this.varietyCropCode = variety.cropCode;
        this.varietyColor = variety.color || '#194D33';
    }

    private submitEditingVariety() {
        const variety = this.currentlyEditingVariety!!;

        this.varietiesRef.doc(variety.id).update(
            {
                name: this.varietyName,
                seedType: this.varietySeedType,
                cropCode: this.varietyCropCode,
                color: this.varietyColor,
            },
        ).then(() => {
            this.loadVarieties(this.currentlyEditingCropId, variety.cropTypeId);
            this.cancelEditingVariety();
        });
    }

    private cancelEditingVariety() {
        this.currentlyEditingVariety = undefined;
        this.currentlyEditingCropId = '';
        this.isEditingVariety = false;
        this.varietyName = '';
        this.varietySeedType = '';
        this.varietyCropCode = '';
    }

    private setDeletingCrop(crop: Crop) {
        this.currentlyDeletingCrop = crop;
        this.isDeletingCrop = true;
    }

    private submitDeletingCrop() {
        // First check to make sure that the crop has no cropTypes
        const ref = this.cropsRef.doc(this.currentlyDeletingCrop!!.id);
        let resultsCount = 0;
        this.$store.dispatch('setLoading');

        this.cropTypesRef.where('cropId', '==', ref).get().then((values) => {
            resultsCount = values.docs.length;

            if (resultsCount === 0) {
                // Proceed
                ref.delete();
                this.$store.dispatch('unsetLoading');
                this.cancelDeletingCrop();
                this.getCropsAction();
            } else {
                this.$store.dispatch('unsetLoading');
                this.$store.dispatch('setError', 'Crop must not have any associated Crop Types to be deleted');
                this.cancelDeletingCrop();
            }
        });
    }

    private cancelDeletingCrop() {
        this.currentlyDeletingCrop = undefined;
        this.isDeletingCrop = false;
    }

    private setDeletingCropType(cropType: CropType) {
        this.currentlyDeletingCropType = cropType;
        this.isDeletingCropType = true;
    }

    private submitDeletingCropType() {
        // First check to make sure that the crop has no cropTypes
        const ref = this.cropTypesRef.doc(this.currentlyDeletingCropType!!.id);
        let resultsCount = 0;
        this.$store.dispatch('setLoading');

        this.varietiesRef.where('cropTypeId', '==', ref).get().then((values) => {
            resultsCount = values.docs.length;

            if (resultsCount === 0) {
                // Proceed
                ref.delete();
                this.$store.dispatch('unsetLoading');
                this.getCropTypesAction(this.currentlyDeletingCropType!!.cropId);
                this.cancelDeletingCropType();
            } else {
                this.$store.dispatch('unsetLoading');
                this.$store.dispatch('setError', 'Crop Type must not have any associated Varieties to be deleted');
                this.cancelDeletingCropType();
            }
        });
    }

    private cancelDeletingCropType() {
        this.currentlyDeletingCropType = undefined;
        this.isDeletingCropType = false;
    }

    private setDeletingVariety(variety: Variety, cropId: string) {
        this.currentlyDeletingVariety = variety;
        this.currentlyEditingCropId = cropId;
        this.isDeletingVariety = true;
    }

    private submitDeletingVariety() {
        const ref = this.varietiesRef.doc(this.currentlyDeletingVariety!!.id);

        ref.delete();
        this.getVarietiesAction(this.currentlyEditingCropId, this.currentlyDeletingVariety!!.cropTypeId);
        this.cancelEditingVariety();
    }

    private cancelDeletingVariety() {
        this.currentlyEditingCropId = '';
        this.currentlyDeletingVariety = undefined;
        this.isDeletingVariety = false;
    }
}
